import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { showErrorToast } from "../../../fnx/showError";
import { useDispatch } from "react-redux";
import { userCreateClearData, userPutRolClearData, } from "../../../store/auth/actions";
export var useErrorHandling = function (_a) {
    var errorIdentificationType = _a.errorIdentificationType, errorGetCatalogsType = _a.errorGetCatalogsType, errorBranches = _a.errorBranches, errorOneClient = _a.errorOneClient, errorRol = _a.errorRol, errorUserPutRol = _a.errorUserPutRol, errorSubmit = _a.errorSubmit, setSeeToast = _a.setSeeToast;
    var dispatch = useDispatch();
    var t = useTranslation().t;
    useEffect(function () {
        if (errorIdentificationType) {
            showErrorToast(errorIdentificationType, setSeeToast, t);
        }
    }, [errorIdentificationType]);
    useEffect(function () {
        if (errorGetCatalogsType) {
            showErrorToast(errorGetCatalogsType, setSeeToast, t);
        }
    }, [errorGetCatalogsType]);
    useEffect(function () {
        if (errorBranches) {
            showErrorToast(errorBranches, setSeeToast, t);
        }
    }, [errorBranches]);
    useEffect(function () {
        if (errorOneClient) {
            showErrorToast(errorOneClient, setSeeToast, t);
        }
    }, [errorOneClient]);
    useEffect(function () {
        if (errorRol) {
            showErrorToast(errorRol, setSeeToast, t);
        }
    }, [errorRol]);
    useEffect(function () {
        if (errorUserPutRol) {
            showErrorToast(errorUserPutRol, setSeeToast, t);
            dispatch(userPutRolClearData());
        }
    }, [errorUserPutRol]);
    useEffect(function () {
        if (errorSubmit) {
            showErrorToast(errorSubmit, setSeeToast, t);
            dispatch(userCreateClearData());
        }
    }, [errorSubmit]);
};
